var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-component",
    {
      attrs: { title: _vm.$helpers.trans("auth.login"), open: _vm.open },
      on: {
        close: function($event) {
          return _vm.$emit("update:open", false)
        }
      }
    },
    [
      _c(
        "form-component",
        {
          attrs: {
            name: "Login",
            action: "/login",
            "success-message": _vm.$helpers.trans("auth.loginSucceeded"),
            "spam-filter": false
          },
          on: {
            success: function($event) {
              return _vm.loginComplete($event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "submit",
              fn: function(slotProps) {
                return _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return slotProps.submit()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fal fa-btn fa-sign-in" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$helpers.trans("auth.login")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-link",
                      attrs: { href: "/password/reset" }
                    },
                    [_vm._v(_vm._s(_vm.$helpers.trans("auth.passwordReset")))]
                  )
                ])
              }
            }
          ])
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.email,
                  expression: "user.email"
                }
              ],
              staticClass: "form-control",
              class: { used: _vm.user.email },
              attrs: {
                id: "login_email",
                type: "email",
                required: "",
                name: "email"
              },
              domProps: { value: _vm.user.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "email", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "login_email" } },
              [
                _c("span", { staticClass: "form-label__content" }, [
                  _vm._v(_vm._s(_vm.$helpers.trans("auth.email")))
                ])
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.password,
                  expression: "user.password"
                }
              ],
              staticClass: "form-control",
              class: { used: _vm.user.password },
              attrs: {
                id: "login_password",
                type: "password",
                required: "",
                name: "password"
              },
              domProps: { value: _vm.user.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "password", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "login_password" } },
              [
                _c("span", { staticClass: "form-label__content" }, [
                  _vm._v(_vm._s(_vm.$helpers.trans("auth.password")))
                ])
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "col-md-6 col-md-offset-4" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.remember,
                        expression: "user.remember"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", name: "remember" },
                    domProps: {
                      checked: Array.isArray(_vm.user.remember)
                        ? _vm._i(_vm.user.remember, null) > -1
                        : _vm.user.remember
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.user.remember,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.user, "remember", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.user,
                                "remember",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.user, "remember", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$helpers.trans("auth.rememberUser")) +
                      "\n                        "
                  ),
                  _c("div", { staticClass: "invalid-feedback" })
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fce8884", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fce8884","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/package/RF/Member/modals/Login.vue
// module id = 250
// module chunks = 17